import React from "react";

export default function PageNotFound() {
	return (
		<div className="center center-content">
			<h3>Oh no, this page doesn't exist!</h3>
			<br />
			<p>Please choose one of the pages from the menu on the left.</p>
		</div>
	);
}
